import { useFormContext } from 'react-hook-form'
import { FlexColumn, FlexRow } from '../../../atoms/layout/Flex'
import Label from '../../../atoms/display/Label'
import TextField from '../../../atoms/inputs/TextField'
import CheckboxControl from '../../../atoms/inputs/CheckboxControl'
import { VisitorRegistrationFormParams } from '../../../../types/Company'

export default function VisitorRegistrationWorkCategoriesForm() {
  const form = useFormContext<VisitorRegistrationFormParams>()
  const { errors } = form.formState

  return (
    <FlexColumn>
      <Label text="事業内容について" variant="subtitle" />
      <FlexRow>
        <FlexRow width={120}>
          <Label text="対応可能工種" />
        </FlexRow>
        <FlexColumn space={0}>
          <FlexRow wrap space={0}>
            <CheckboxControl control={form.control} name="workCategory1" label="屋根" />
            <CheckboxControl control={form.control} name="workCategory2" label="外壁" />
            <CheckboxControl control={form.control} name="workCategory3" label="足場" />
            <CheckboxControl control={form.control} name="workCategory4" label="太陽光" />
            <CheckboxControl control={form.control} name="workCategory5" label="電化" />
            <CheckboxControl control={form.control} name="workCategory6" label="蓄電池" />
            <CheckboxControl control={form.control} name="workCategory7" label="浄化槽" />
            <CheckboxControl control={form.control} name="workCategory8" label="外構" />
            <CheckboxControl control={form.control} name="workCategory9" label="基礎" />
            <CheckboxControl control={form.control} name="workCategory10" label="内装" />
            <CheckboxControl control={form.control} name="workCategory11" label="水回り" />
            <CheckboxControl control={form.control} name="workCategory12" label="床下" />
            <CheckboxControl control={form.control} name="workCategory13" label="増改築" />
          </FlexRow>
          <FlexRow align="flex-start">
            <FlexRow width={100}>
              <CheckboxControl control={form.control} name="workCategoryOther" label="その他" />
            </FlexRow>
            <FlexRow width={480}>
              <TextField
                register={form.register('workCategoryOtherText')}
                error={errors.workCategoryOtherText?.message}
              />
            </FlexRow>
          </FlexRow>
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
  )
}
